<template>
  <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
    <div class="px-4 py-5 flex-auto">
      <div
        class="text-black p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-gray-300"
      >
        <i :class="icon"></i>
      </div>
      <h6 class="text-xl font-semibold">{{title}}</h6>
      <p class="mt-2 mb-4 text-gray-600">{{subtitle}}</p>
      <div v-if="scrollTo && scrollTo !== ''" class="bg-white border border-gray-400 p-4 text-gray-600 rounded-lg">
        <a :href="scrollTo" v-smooth-scroll>Mehr erfahren</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    icon: {
      type: String
    },
    scrollTo: {
      type: String
    }
  }
};
</script>

<style>
</style>